import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ImageCropperComponent, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';

@Component({
  selector: 'xemex-crop-photo-dialog',
  imports: [MatIconModule, MatButtonModule, ImageCropperComponent, TranslateModule],
  templateUrl: './crop-photo-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './crop-photo-dialog.component.scss',
})
export class CropPhotoDialogComponent {
  imageFile: File;
  croppedImage: SafeUrl = '';
  imageBlob: Blob | undefined | null;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<CropPhotoDialogComponent>,
    private sanitizer: DomSanitizer,
  ) {
    this.imageFile = data.imageFile;
  }

  imageCropped(event: ImageCroppedEvent) {
    if (!event.objectUrl) {
      return;
    }
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
    this.imageBlob = event.blob;
  }

  onUpload() {
    this.dialogRef.close({
      croppedImage: this.croppedImage,
      imageBlob: this.imageBlob,
    });
  }
}
